module.exports = __webpack_public_path__ + "img/roxana-blenche-up-online-banner.b89a168f.png";